import { createContext } from 'react';

const dataAndMethodsContext: any = createContext('');

export default dataAndMethodsContext;